import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { ProductDesign } from '@inter-ikea-storageone/range';
import { extractImageSource } from 'utils/imageUtils';
import { getFilterState, getSelectedGroupId } from 'ducks/products';
import sheetImageWhite from './boaxel_mounting_rail_info_white.png';
import sheetImageAnthracite from './boaxel_mounting_rail_info_anthracite.png';

type ColorFilterState = {
  design: ProductDesign;
};

const ImageWrapper = styled.div`
  width: 100%;
  height: 384px;
  margin-block: 24px 16px;
`;

const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const MountingRailInfoCard = () => {
  const { formatMessage } = useIntl();
  const selectedGroupId = useSelector(getSelectedGroupId);
  const filterState = useSelector(getFilterState);

  const colorFilterState = filterState(selectedGroupId, 'design') as ColorFilterState;

  const imageSources: { [design: string]: string } = {
    [ProductDesign.WHITE]: sheetImageWhite,
    [ProductDesign.ANTHRACITE]: sheetImageAnthracite
  };

  const image = { src: imageSources[colorFilterState.design], width: 400, height: 384 };
  const { fallbackImage } = extractImageSource([image]);

  return (
    <ImageWrapper>
      <Image
        src={fallbackImage.src}
        alt={formatMessage({ id: 'storageone.mountingRailInfoCardImageAltText' })}
      />
    </ImageWrapper>
  );
};

export default MountingRailInfoCard;
